export const ROBOTS_TXT_PATH = '/robots.txt';
